import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData, getInputParams } from '../CustomUtils'
import { NEW_LOSS_SETTLEMENT_REPORT_QUERY, FORECAST_LOSS_SETTLEMENT_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ParameterValues from '../ParameterValues.js'
import ResultsGrid from '../ResultsGrid.js'
import { getTenant } from '../../../utils.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import TotalsRow from '../TotalsRow.js'

const NEW_LOSS_SETTLEMENT_REPORT = gql(NEW_LOSS_SETTLEMENT_REPORT_QUERY)
const FORECAST_LOSS_SETTLEMENT_REPORT = gql(FORECAST_LOSS_SETTLEMENT_REPORT_QUERY)

// used for NewLossSettlementReport and ForecastLossSettlementReport

export default function LossSettlementReport({ location }) {
  console.log('LossSettlementReport rendered:', location)
  const inputs = getInputParams(location)
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [printView, setPrintView] = useState(false)

  useEffect(() => {
    if (inputs.printView) {
      delete inputs.printView
      location.search = `?inputs=${JSON.stringify(inputs)}`
      setPrintView(true)
    }
    if (location.pathname.split('/')[2] === 'forcast.loss_settlement_list_report' || location.pathname.split('/')[3] === 'forcast.loss_settlement_list_report') {
      getData(location, FORECAST_LOSS_SETTLEMENT_REPORT, 'forecastLossSettlementReport', setResults, setGraphQLErrors)
    } else {
      getData(location, NEW_LOSS_SETTLEMENT_REPORT, 'newLossSettlementReport', setResults, setGraphQLErrors)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  let total = 0
  function totalFunction(number) {
    if (number !== '') {
      total += parseFloat(number.replace(/,/g, ''))*100
    }
  }
  function printViewClicked() {
    inputs.printView = true
    const link = document.createElement('a')
    link.href = `/asbestos/nonav/custom/${location.pathname.split('/')[2]}?inputs=${JSON.stringify(inputs)}`
    link.setAttribute('target', '_blank')
    link.click()
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    let drawPrintView = <Button color="primary" style={{marginRight: '5px'}} onClick={printViewClicked}>Printable View</Button>
    if (printView) {
      drawPrintView= ''
    }
    const resultRows = ResultsGrid(results, 0, null, null, null, 16, null, totalFunction ) 
    total /= 100
    let csvData = ''
    if (location.pathname.split('/')[2] === 'forcast.loss_settlement_list_report') {
      csvData = 'forecastLossSettlementReport'
    } else {
      csvData = 'newLossSettlementReport'
    }
    const csvUrl = `${process.env.REACT_APP_SERVER}/csv/${getTenant()}/custom/Asbestos/${csvData}/loss_settlement.csv?inputs=${JSON.stringify(inputs)}`
    let drawCSV = <LargeRowHandler csvUrl={csvUrl} resultsLength={results.reportData.length} />
    if (printView) {
      drawCSV = ''
    }
    let forcastTitleText = ''
    if (location.pathname.split('/')[2] === 'forcast.loss_settlement_list_report' || location.pathname.split('/')[3] === 'forcast.loss_settlement_list_report') {
      forcastTitleText = 'Forcast'
    }
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          {drawPrintView}
          {drawCSV}
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title={`${forcastTitleText} Loss Settlement List Report`} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
            <TotalsRow columnNumber={16} total={total} />
          </tbody>
        </Table>
      </div>
    )
  }
}